import React from "react";
import { FiLinkedin, FiGithub } from "react-icons/fi";
import { AiOutlineMail, AiFillPhone, AiOutlineWhatsApp } from "react-icons/ai";
import { FooterOverlay, Newsletter } from "../../components";
import { images } from "../../constants";
import "./Footer.css";
const Footer = () => (
  <div className="app__footer section__padding" id="login">
    <FooterOverlay />
    <Newsletter />

    <div className="app__footer-links">
      <div className="app__footer-links_contact">
        <h1 className="app__footer-headtext">Contact Us</h1>
        <p className="p__opensans">9 W 53rd St, New York, NY 10019, USA</p>
        <p className="p__opensans">+1 212-344-1230</p>
        <p className="p__opensans">+1 212-555-1230</p>
      </div>

      <div className="app__footer-links_logo" id="contact">
        <img src={images.gericht} alt="footer_logo" />
        <p className="p__opensans">
          &quot;The best way to find yourself is to lose yourself in the service
          of others.&quot;
        </p>
        <img
          src={images.spoon}
          className="spoon__img"
          style={{ marginTop: 15 }}
        />
        <div className="app__footer-links_icons">
          <a
            href="https://www.linkedin.com/in/sayed-hany-b30946192/"
            target="_blank"
          >
            <FiLinkedin />
          </a>
          <a href="https://github.com/sayedhany" target="_blank">
            <FiGithub />
          </a>
          <a target="_blank" href="mailto:sayedhany975@gmail.com">
            <AiOutlineMail />
          </a>
          <a target="_blank" href="tel:0201201500975">
            <AiFillPhone />
          </a>
          <a href="https://api.whatsapp.com/send?phone=0201201500975">
            <AiOutlineWhatsApp />
          </a>
        </div>
      </div>

      <div className="app__footer-links_work">
        <h1 className="app__footer-headtext">Working Hours</h1>
        <p className="p__opensans">Monday-Friday:</p>
        <p className="p__opensans">08:00 am - 12:00 am</p>
        <p className="p__opensans">Saturday-Sunday:</p>
        <p className="p__opensans">07:00 am - 11:00 pm</p>
      </div>
    </div>

    <div className="footer__copyright">
      <p className="p__opensans">2023 Sayed Hany. All Rights reserved.</p>
    </div>
  </div>
);

export default Footer;
